import React from "react";
import { useParams } from "react-router-dom";

const OpenFineTuneJob = ({
    account_id
}) => {
    const { org_id, ft_id } = useParams()
    return (
        <div className="finetune_main">
            
        </div>
    )
}

export default OpenFineTuneJob